import React from "react"
import { appTools, cn } from "lib/utils"
import { FormLabel } from "lib/components"



export default function FieldGroup({ 
  label,
  required=false,
  className, 
  children, 
  ...rest
}:{ 
  label?:string
  required?:boolean
  className?:string
  children:React.ReactNode;
  [key:string]:any 
}){

  return (
    <div className={cn("w-full flex flex-col mb-4 gap-1", className)} {...rest}>
      { label && <FormLabel required={required} className="pl-1 uppercase text-sm">{label}</FormLabel> }
      {children}
    </div>
  )
}